import {
    BG_ACTIVE,
    BG_CLOSE
} from './mutations-types'


export default {
    [BG_ACTIVE](state,{idx,isTrue}){
        state.bgActive[idx] = isTrue;
    },
    [BG_CLOSE](state){
        state.bgActive = [];
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js